import { ActionTree } from 'vuex';
import ActionTypes from '@/constants/action-types';
import { RootState } from '@/store/state';
import { merchantApiService } from '@/api';
import { MerchantsRequest } from '@/types';
import { MerchantModel } from '@/models/MerchantModel';

const actions: ActionTree<RootState, RootState> = {

  async [ActionTypes.GetMerchantsPage]({ commit }, req?: MerchantsRequest) {
    const merchantList: MerchantModel[] = await merchantApiService.getMerchantsPage(req);
    const payload = { merchantList };
    if (req && Number(req.page) > 1) {
      Object.assign(payload, { initialPage: false });
    }

    return commit(ActionTypes.GetMerchantsPage, payload);
  },

};

export default actions;
